import React from "react";
import Layout from "../../components/layout/layout";
import { graphql, PageProps } from "gatsby";
import { PaddedContent, Categories } from "./content-hub.styled";
import {
  ContentHubPageQuery,
  ContentCategoryFragment,
  ContentPostFragment,
  SeoSliceFragment,
  LocalesSliceFragment,
  ContentPostsByCategoriesQuery,
  PrismicContentCategory,
} from "../../types/graphql";
import HeroContentHub from "../../components/hero-content-hub/hero-content-hub";
import CategoriesBar from "../../components/categories-bar/categories-bar";
import FeaturedPosts from "../../components/featured-posts/featured-posts";
import ContentHubCategory from "../../components/content-hub-category/content-hub-category";
import { withPrismicPreview } from "gatsby-plugin-prismic-previews";
import Breadcrumbs, {
  BreadCrumbProps,
} from "../../components/breadcrumbs/breadcrumbs";
import { linkTo } from "../../utils/contentUtils";
import { ISeoProps } from "../../components/seo/seo";
import { ILocalesProps } from "../../components/locales/locales";
import * as prismicHelper from "@prismicio/helpers";
import { ILocationStateProps, IPageContext } from "../../types/types";

export const query = graphql`
  query ContentHubPage {
    allPrismicContentHub {
      nodes {
        _previewable
        ...FeaturedPosts
        ...ContentHub
      }
    }
    allPrismicContentPost(limit: 4, sort: { last_publication_date: DESC }) {
      nodes {
        ...ContentPost
      }
    }
  }
`;

export type PostsByCategory = {
  categoryData: PrismicContentCategory;
  posts: ContentPostsByCategoriesQuery["allPrismicContentPost"]["group"][number]["edges"];
};

const ContentHub = (
  props: PageProps<ContentHubPageQuery, IPageContext, ILocationStateProps>
) => {
  const heroContentHub = props.data.allPrismicContentHub.nodes?.find(
    () => true
  );

  const postsByCategories = props.pageContext.postsByCategories;
  const seoSlices = heroContentHub?.data?.body;

  let seo: ISeoProps = {};
  let pageLocale: ILocalesProps = {};

  seoSlices?.forEach((slice) => {
    if (slice?.slice_type == "page_locales") {
      pageLocale = {
        ...slice,
        northAmericaHref: props.location.href,
      };
    } else if (slice?.slice_type == "seo_") {
      const seoSlice = slice as SeoSliceFragment;
      seo = {
        meta_title: seoSlice?.primary?.meta_title,
        meta_description: seoSlice.primary?.meta_description,
        title: heroContentHub?.data?.content_hub_name,
        description:
          heroContentHub?.data?.content_hub_description &&
          prismicHelper.asText(
            heroContentHub?.data?.content_hub_description.richText
          ),
        image: heroContentHub?.data?.content_hub_image?.url,
        lang: heroContentHub?.lang,
      };
    }
  });

  const breadcrumbs: BreadCrumbProps[] =
    (heroContentHub && [
      {
        name: "Resources",
        url: linkTo(heroContentHub),
      },
    ]) ||
    [];

  return (
    (heroContentHub && (
      <Layout isGuttered={false} seo={seo} locales={pageLocale}>
        <PaddedContent>
          <Breadcrumbs breadcrumbs={breadcrumbs} />
          <HeroContentHub heroContentHub={heroContentHub} />
          <CategoriesBar />
          <FeaturedPosts
            featuredPosts={heroContentHub}
            recentPosts={props.data.allPrismicContentPost}
          />
          {postsByCategories && (
            <Categories>
              {postsByCategories
                .sort((categoryA, categoryB) => {
                  if (!categoryA.categoryData || !categoryB.categoryData) {
                    return 0;
                  }
                  const dateA = new Date(
                    categoryA.categoryData.last_publication_date
                  );
                  const dateB = new Date(
                    categoryB.categoryData.last_publication_date
                  );
                  if (dateA > dateB) {
                    return 1;
                  } else if (dateA < dateB) {
                    return -1;
                  } else {
                    return 0;
                  }
                })
                .map((category, index) => {
                  return (
                    <ContentHubCategory
                      key={index}
                      contentHubCategory={category}
                    />
                  );
                })}
            </Categories>
          )}
        </PaddedContent>
      </Layout>
    )) || <></>
  );
};

export default withPrismicPreview(ContentHub as any);
